import { Device } from '../types/types';
import { createSelector } from 'reselect';
import { AppRootState } from '../reducers';
import { toCamelCase } from './snakeCaseToCamelCase';

/*
 */
const getRobotsBasicInfo = (robots: Array<Device>) => {
	return robots.map(robot => ({
		name: robot.name,
		deviceId: robot.deviceId,
		orgId: robot.orgId,
		deviceType: robot.deviceType,
		deviceGroupsIds: robot.deviceGroupsIds
	}));
};

/*
 */
const getAllRobotsBasicInfo = (state: any, orgId?: string) => {
	let deviceByOrg = state.deviceState?.devicesByOrganizationId as Record<
		string,
		Record<string, Device>
	>;
	if (!deviceByOrg) return [];
	if (orgId) deviceByOrg = deviceByOrg[orgId];
	if (!deviceByOrg || (deviceByOrg && Object.keys(deviceByOrg).length === 0)) return [];
	const devicesArray = Object.values<Record<string, Device>>(deviceByOrg)
		.map(devicesMap => {
			return orgId ? (devicesMap as Device) : Object.values<Device>(devicesMap);
		})
		.flat();
	return getRobotsBasicInfo(devicesArray);
};

/*
 */
export const getDevices = createSelector([getAllRobotsBasicInfo], devices => {
	return devices;
});

const getSpecificEntityInfo = (
	state: AppRootState,
	entityState: keyof AppRootState,
	identifiers: { entityId?: string; orgId: string; propertyOptions: Array<string> }
) => {
	let { entityId, orgId, propertyOptions } = identifiers;
	let entity: Record<string, any> = {};
	let singleEntity: Record<string, any>;
	switch (entityState) {
		case 'deviceState':
			singleEntity = state[entityState].devicesByOrganizationId[orgId][entityId!];
			break;
		case 'usersState':
			singleEntity = state[entityState].usersByOrganizationId[orgId][entityId!];
			break;
		case 'userGroupsState':
			singleEntity = state[entityState].userGroupsByOrganizationId[orgId!][entityId!];
			break;
		case 'deviceGroupsState':
			singleEntity = state[entityState].deviceGroupsByOrganizationId[orgId][entityId!];
			break;
		case 'organizationState':
			singleEntity = state[entityState].organizations[orgId!];
			break;
		case 'accountState':
			singleEntity = state[entityState].user.devices[toCamelCase(entityId!)];
			break;
		default:
			break;
	}

	try {
		propertyOptions.forEach(key => {
			if (!singleEntity) return entity;
			else entity[key] = singleEntity[key];
		});
	} catch (error) {
		console.log(error);
	}

	return entity;
};

/*
 */
export const getStateEntityByOrgId = createSelector([getSpecificEntityInfo], entity => {
	return entity;
});

/*
 */
export const equalityFnc = (prevState: any, nextState: any, shouldUpdate = true) => {
	if (!shouldUpdate) return true;
	return JSON.stringify(prevState) === JSON.stringify(nextState);
};
